
import { ReactNode } from 'react';

interface HolographicCardProps {
  children: ReactNode;
  className?: string;
}

export default function HolographicCard({ children, className = '' }: HolographicCardProps) {
  return (
    <div
      className={`relative backdrop-blur-md bg-gradient-to-br from-white/5 to-white/2 border border-white/15 rounded-xl shadow-2xl hover:shadow-cyan-500/20 transition-all duration-300 hover:border-cyan-400/40 ${className}`}
      style={{
        background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%)',
        backdropFilter: 'blur(20px)',
        boxShadow: '0 25px 45px -12px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
      }}
    >
      {children}
    </div>
  );
}
